import React from "react";
import { CURRENCY } from "src/lib/constans";

interface IProps {
  orderTotal?: number;
  shipping?: number;
  isPharma?: boolean;
}

const OrderDetailsBox: React.FC<IProps> = ({ orderTotal, shipping , isPharma}) => {
  return (
    <div className="w-full 2xl:p-3 p-2.5 bg-white border border-gray-200 rounded-lg shadow-sm">
      <h3 className="font-Poppins-Medium font-size-18px text-[#202020] 2xl:mb-4 mb-2">
        Order Details
      </h3>

      <div className="2xl:space-y-2 space-y-1 text-sm">
        <div className="flex justify-between">
          <span className="font-Poppins-Regular font-size-15px text-[#5B5B5B]">
            Order Total
          </span>
          <span className="font-Poppins-Regular font-size-15px text-[#5B5B5B]">
            {CURRENCY} {orderTotal ? orderTotal.toFixed(2) : "0.00"}
          </span>
        </div>
        {/* <div className="flex justify-between">
          <span className="font-Poppins-Regular font-size-15px text-[#5B5B5B]">
            Discount
          </span>
          <span className="font-Poppins-Regular font-size-15px text-[#5B5B5B]">
            -{CURRENCY} 56.00
          </span>
        </div> */}
        {isPharma && <div className="flex justify-between">
          <span className="font-Poppins-Regular font-size-15px text-[#5B5B5B]">
            Shipping
          </span>
          <span className="font-Poppins-Regular font-size-15px text-[#5B5B5B]">
            {CURRENCY} {shipping ? shipping.toFixed(2) : "0.00"}
          </span>
        </div>}
        {/* <div className="flex justify-between">
          <span className="font-Poppins-Regular font-size-15px text-[#5B5B5B]">
            Estimate VAT
          </span>
          <span className="font-Poppins-Regular font-size-15px text-[#5B5B5B]">
            {CURRENCY} 19.21
          </span>
        </div> */}
      </div>

      <div className="flex justify-between items-center 2xl:mt-2 mt-1 text-base">
        <span className="font-Poppins-Medium font-size-16px text-[#2F2F31]">
          Total Amount
        </span>
        <span className="font-Poppins-Medium font-size-16px text-[#2F2F31]">
          {CURRENCY} {((orderTotal ? orderTotal : 0) + (shipping ? shipping : 0)).toFixed(2)}
        </span>
      </div>
    </div>
  );
};

export default OrderDetailsBox;
